import script from "./ProjectsOverviewDewarmsteweek.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsOverviewDewarmsteweek.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsOverviewDewarmsteweek.vue?vue&type=style&index=0&id=953fcb22&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953fcb22"]])

export default __exports__